import { sortBy } from 'lodash';

import chatCampaignsResource from 'src/actions/chatCampaigns/chatCampaignsResource';
import { useResourceValues } from 'src/presentation/hooks/useResource';

export default function useChatCampaigns() {
  const { loadingState, values } = useResourceValues(chatCampaignsResource);
  return {
    loadingState,
    values: sortBy(
      values.map(({ id, name }) => {
        return { label: name, value: id };
      }),
      ['label']
    ),
  };
}
